import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {  FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, SMALL_TEXT_PX, TERTIARY_FONT_COLOR, TITLE_FONT_COLOR, X_SMALL_TEXT_PX } from '../../../styles/fonts/MCFontConstants';
export const ProcedureLevel = styled.div`
    font-family: ${FONT_FAMILY_DEMI};  
    margin: 1px;
    display: flex;
`;
export const LevelDropdownContainer = styled.div`
    opacity: 1;
    ${'' /* width: 65px; */}
    margin: 0 0 0 auto;
    ${media.smalDevice`
        ${'' /* height: 74px; */}
        width:100%;
    `}
    ${media.mobileDevice`
        ${'' /* height: 74px; */}
    `}
`;
export const LevelContainer = styled.div`
    margin-bottom:  ${({marginBottom})=>(marginBottom ? marginBottom:'10px')};
    ${media.smalDevice`
        margin-bottom: 0px;
    `}
`;

export const StyledText = styled.span`
    font-size: ${SMALL_TEXT_PX};
    letter-spacing: 0px;
    color: ${TITLE_FONT_COLOR};
    opacity: 1;
    margin-left: 35px;
    font-family: ${FONT_FAMILY_REGULAR};
    cursor: pointer;
`;
export const SubTitle = styled.div`
    font-family: ${({ fontStyle }) =>
        fontStyle ? fontStyle : FONT_FAMILY_REGULAR};
    color: ${TERTIARY_FONT_COLOR};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : X_SMALL_TEXT_PX)};
    margin: ${({ margin }) => (margin ? margin : '0 0 8px 0')};
    padding: ${({ padding }) => (padding ? padding : '')};
    padding-bottom: 0px;
    padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '0px')};
    paddingleft: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '0px')};
`;

// export const SubTitle = styled.div`
//     font-family: AvenirNextWorld Italic;
//     color: #140f4b;
//     font-size: ${({fontSize}) => (fontSize ? fontSize : '12px')};
//     margin: ${({ margin }) => (margin ? margin : '0 0 8px 0')};
//     padding: ${({ padding }) => (padding ? padding : '')};
//     display: flex;
//     justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : 'flex-start')};
// `;
export const LevelTitle = styled.div`
    display: flex;
`;